import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Atmosphere, CTA, Shell } from "../components/site/Primitives";
import Wordmark from "../components/site/Wordmark";

export default function ErrorPage({ code = "404" }) {
  const copy =
    code === "500"
      ? {
          title: "Something broke on our side.",
          sub: "An unexpected error occurred. Reloading usually clears it — if it doesn't, email us and we'll look into it.",
        }
      : {
          title: "This page doesn't exist.",
          sub: "The link may be outdated, or the page may have moved. Here are the routes people usually want.",
        };

  return (
    <div data-testid={`error-page-${code}`} className="relative min-h-screen overflow-hidden bg-elv-base">
      <Atmosphere />
      <Shell className="relative flex min-h-screen flex-col justify-center py-24">
        <Wordmark />
        <p className="mt-16 font-mono text-[11px] uppercase tracking-[0.3em] text-elv-green">Error {code}</p>
        <h1 className="mt-6 max-w-2xl text-4xl font-semibold leading-[1.05] text-elv-text sm:text-5xl">
          {copy.title}
        </h1>
        <p className="mt-6 max-w-xl text-sm text-elv-dim md:text-base">{copy.sub}</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <CTA to="/" testId="error-home">
            Back to home
          </CTA>
          <CTA to="/book-demo" variant="ghost" testId="error-book-demo">
            Book a Free AI Demo
          </CTA>
          {code === "500" ? (
            <button
              type="button"
              data-testid="error-reload"
              onClick={() => window.location.reload()}
              className="px-3 py-3 text-sm text-elv-dim underline underline-offset-4 hover:text-elv-text"
            >
              Reload page
            </button>
          ) : null}
        </div>
        <div className="mt-14 flex flex-wrap gap-x-8 gap-y-3 border-t border-elv-line pt-8">
          {[
            ["/features", "Features"],
            ["/pricing", "Pricing"],
            ["/industries", "Industries"],
            ["/contact", "Contact"],
            ["/login", "Client Login"],
          ].map(([to, label]) => (
            <Link
              key={to}
              to={to}
              data-testid={`error-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="inline-flex items-center gap-1.5 text-sm text-elv-dim hover:text-elv-green"
            >
              <Icons.ArrowUpRight className="h-3.5 w-3.5" />
              {label}
            </Link>
          ))}
        </div>
      </Shell>
    </div>
  );
}
